import { render } from "./account-type.vue?vue&type=template&id=462ec9da&lang=html"
import script from "./account-type.vue?vue&type=script&lang=js"
export * from "./account-type.vue?vue&type=script&lang=js"

import "./account-type.vue?vue&type=style&index=0&id=462ec9da&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__